import Swal from 'sweetalert2'

$(document).ready(function() {
    const surveys = {
        isLoading: false,
        init() {
            $(document).on('click', '#submit-survey-form', this, this.send);
        },
		send(event) {
			const _this = event.data;

			if (!$('#terms_and_conditions').is(":checked")) {
				Swal.fire(
					'Error',
					$('#terms_and_conditions').data('text'),
					'error'
				);
				$('#terms_and_conditions').addClass('is-invalid');
				return;
			}

			if (_this.isLoading) { return false; }

			let route = $(this).data('route');
			let id = $(this).data('id');
			let token = $(this).data('token');

			var values = '_token=' + $('meta[name="csrf-token"]').attr('content');
			values += '&id=' + id;
			values += '&token=' + token;
			values += '&recent_experience=' + $('#recent_experience').val();
			values += '&agent_kindness=' + $('#agent_kindness').val();
			values += '&fleet_diversity=' + ($('input[name="fleet_diversity"]:checked').val()?$('input[name="fleet_diversity"]:checked').val():0);
			values += '&fleet_diversity_note=' + $('#fleet_diversity_note').val();
			values += '&vehicle_technical_problem=' + ($('input[name="vehicle_technical_problem"]:checked').val()?$('input[name="vehicle_technical_problem"]:checked').val():0);
			values += '&vehicle_technical_problem_note=' + $('#vehicle_technical_problem_note').val();
			values += '&other_observations=' + $('#other_observations').val();
			$.ajax({
				type: "POST",
				url: `${route}`,
				data: values,
				beforeSend: function() {},
				complete: function() {},
				success: function(response, xhr) {
					_this.isLoading = false;

					if (response.status == 1) {
						$('.survey-form-container').html(`<div class="alert alert-success success-wrapper alert-dismissible fade show mt-4 shadow-lg" role="alert">
							<div class="text-center pb-3">
								<i class="far fa-thumbs-up fa-2x"></i>
							</div>
							<strong>${response.message}</strong>
							<button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
						</div>`);
						
						Swal.fire(
							'Success',
							response.message,
							'success'
						);
						return false;
					}

					Swal.fire(
						'Error',
						response.message,
						'error'
					);
				},
				error(error) {
					_this.isLoading = false;
					alert('Error: Something went wrong please contact an administrator!');
				},
			});
		},
    };

    if ($('.survey-form').length) {
        surveys.init();
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/surveys.js